import { DialedDigitExtractionServerUpdateCallback } from 'data/template/template.types';
import { useDialedDigitExtractionServerFieldCreateNewNetwork } from './useDialedDigitExtractionServerFieldCreateNewNetwork';

// eslint-disable-next-line import/prefer-default-export
export function useDialedDigitExtractionServerFieldCreateNew(
  handleFieldUpdate: DialedDigitExtractionServerUpdateCallback,
): [DialedDigitExtractionServerUpdateCallback] {
  const [handleFieldNewNetworkId] = useDialedDigitExtractionServerFieldCreateNewNetwork(handleFieldUpdate);

  const handleFieldCreateNew: DialedDigitExtractionServerUpdateCallback = (param) => {
    const { name } = param;
    if (name === 'ownnetid') {
      handleFieldNewNetworkId(param);
    }
  };

  return [handleFieldCreateNew];
}
